// extracted by mini-css-extract-plugin
export default {"description":"ForthScreen_description__rhGw+","title":"ForthScreen_title__0AE7z"};